import md5 from 'md5';

const GRAVATAR_BASE_URL = 'https://www.gravatar.com';

export type GravatarOpts = {
    size?: number; // 1..2048
    rating?: 'g' | 'pg' | 'r' | 'x';
    defaultImage?:
        | '404'
        | 'mp'
        | 'identicon'
        | 'monsterid'
        | 'wavatar'
        | 'retro'
        | 'blank'
        | string;
    forceDefault?: boolean; // always use default image even if user has one
};

/** The session avatar URL both apps feed MyAccountMenu: with the default
 * `404` image, accounts without a Gravatar fall back to the initials chip. */
export function gravatarUrl(email: string, opts: GravatarOpts = {}) {
    const norm = email.trim().toLowerCase();
    const hash = md5(norm);
    const u = new URL(`/avatar/${hash}`, GRAVATAR_BASE_URL);
    if (opts.size) u.searchParams.set('s', String(opts.size));
    if (opts.rating) u.searchParams.set('r', opts.rating);
    u.searchParams.set('d', opts.defaultImage ?? '404');
    if (opts.forceDefault) u.searchParams.set('f', 'y');
    return u.toString();
}
